import React from 'react';
import {connect} from 'react-redux';
import ReactTable from 'react-table';

import axios from 'axios';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import { playerActions } from '../../actions';

class AdminViewGameModal extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            selectedGame: null,
            modal: false,
            players: [],
            loading: true
        }
    }

    toggle = () => {
        this.setState({ modal: !this.state.modal });
    }

    selectGame = (game) => {
        this.setState({ loading: true });
        this.setState({selectedGame: game});
        axios.get(`/api/games/${game.id}/players`)
            .then(response => {
                this.setState({players: response.data});
                this.setState({pageSize: response.data.length});
                this.setState({ loading: false });
            });
        this.toggle()
    }

    renderModal(){
        if(this.state.selectedGame){
            const columns = [ {
                id: 'name',
                Header: 'Name',
                accessor: g => {
                    return `${g.firstName} ${g.lastName}`;
                }
            }, {
                id: 'team',
                Header: 'Team',
                accessor: g => {
                    let team;
                    if(g.team >= 0 && g.team !== null){
                        team = g.team == 0 ? 'White' : 'Black';
                    }
                    return team;
                },
                minWidth: 60
            }, {
                id: 'isGoalie',
                Header: 'Goalie',
                accessor: g => {
                    return g.isGoalie ? 'Yes' : 'No';
                }
            }];
            const { players, loading } = this.state;
            const closeBtn = <button className="close" onClick={this.toggle}>&times;</button>;

            return <Modal isOpen={this.state.modal} toggle={this.toggle} size='lg'>
                        <ModalHeader toggle={this.toggle} close={closeBtn}>Roster</ModalHeader>
                        <ModalBody>
                                <ReactTable
                                    data={players}
                                    columns={columns}
                                    defaultPageSize={10}
                                    loading={loading}
                                    className="playerChart"
                                />
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={this.toggle}>Close</Button>
                        </ModalFooter>
                    </Modal>
        } else {
            return null;
        }
    }

    render(){
        return (
            <span>
            <Button color="link" className="mt3" onClick={this.selectGame.bind(null, this.props.game)} disabled={(this.props.game.playerCount === 0 && this.props.game.goalieCount === 0) || false} style={{fontSize: '15px', paddingLeft: '5px'}}>View Roster</Button>
                {this.renderModal()}
            </span>
        );
    }
}

export default connect(null, playerActions)(AdminViewGameModal);


// WEBPACK FOOTER //
// ./src/components/Games/GameRoster.js